import React, { useEffect } from 'react';
import { Provider } from 'react-redux';
import configureStore from 'src/redux/store';
import { initNetworkDiagnostics } from 'src/utils/networkDiagnostics';
import ReactNotification from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css';
import './App.css';
import { MainComponent } from '../MainComponent/MainComponent';

const store = configureStore();

const App: React.FC = () => {
  useEffect(() => {
    const blockContextMenu = (e: MouseEvent) => {
      e.preventDefault();
    };
    document.addEventListener('contextmenu', blockContextMenu);
    return () =>
      document.removeEventListener('contextmenu', blockContextMenu);
  }, []);

  useEffect(() => {
    return initNetworkDiagnostics();
  }, []);

  return (
    <Provider store={store}>
      <ReactNotification />
      <div className="App">
        <MainComponent />
      </div>
    </Provider>
  );
};

export default App;
